import { render, staticRenderFns } from "./ConsignmentTableLine.vue?vue&type=template&id=6ad10a4a&"
import script from "./ConsignmentTableLine.vue?vue&type=script&lang=js&"
export * from "./ConsignmentTableLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports